"use client";
import { jsx as n, jsxs as $, Fragment as ee } from "react/jsx-runtime";
import { forwardRef as Q, memo as F, useState as fe, useEffect as be, useMemo as Se } from "react";
import te from "react-textarea-autosize";
import * as ie from "@radix-ui/react-avatar";
import * as V from "@radix-ui/react-checkbox";
import * as U from "@radix-ui/react-popover";
import * as k from "@radix-ui/react-tooltip";
import * as K from "@radix-ui/react-hover-card";
import * as x from "@radix-ui/react-scroll-area";
import * as f from "@radix-ui/react-select";
import { Overlay as ae, Content as ne, Close as se, Title as re, Root as oe } from "../atoms/dialog.js";
import { HiMiniBolt as Ee } from "../node_modules/.pnpm/react-icons@5.4.0_react@19.0.0/node_modules/react-icons/hi2/index.js";
import { IoAdd as ke } from "../node_modules/.pnpm/react-icons@5.4.0_react@19.0.0/node_modules/react-icons/io5/index.js";
import Be from "../atoms/avatars/ai.js";
import Te from "../atoms/avatars/user.js";
import { CustomIcon as A } from "../atoms/icons/custom-icon.js";
import { BuiltInIconRenderer as B } from "../atoms/icons/built-in-icon-renderer.js";
import { LinkWithQueryParams as ye } from "../atoms/link.js";
import { Markdown as ce } from "../atoms/markdown/index.js";
import { AttachmentItemProvider as Ae, useAttachmentItem as D } from "../providers/attachment-item-provider.js";
import { AttachmentsBarProvider as we, useAttachmentsBar as M } from "../providers/attachments-bar-provider.js";
import { SourceItemProvider as He, useSourceItem as w } from "../providers/source-item-provider.js";
import { useInkeepConfig as u } from "../providers/config-provider.js";
import { useInkeepConversation as q, SHARE_QUERY_PARAM as Le } from "../providers/conversation-provider.js";
import { useChatEvents as j } from "../providers/chat-events-provider.js";
import { useMessageFeedback as de } from "../providers/feedback-provider.js";
import { MessageAttachmentsProvider as xe, useMessageAttachments as G } from "../providers/message-attachments-provider.js";
import { MessageProvider as De, useMessage as _ } from "../providers/message-provider.js";
import { CheckboxIcon as Pe } from "../atoms/icons/checkbox-icon.js";
import { useCopyToClipboard as Z } from "../hooks/use-copy-to-clipboard.js";
import { FeedbackItemProvider as Oe, useFeedbackItem as me } from "../providers/feedback-item-provider.js";
import { stringifyAttachments as We } from "../utils/get-message-metadata.js";
import { dataAttr as v, maybeRender as I, getInitials as Ne, getMessageContent as le } from "../utils/misc.js";
import { ikp as i } from "./factory.js";
import { useChat as g } from "./embedded-chat/chat-provider.js";
import { ChatProvider as Zr } from "./embedded-chat/chat-provider.js";
import Re from "./tagline-logo-icon.js";
import { useSettleAction as $e } from "../hooks/use-settle-action.js";
import { useContainerSize as Qe } from "../hooks/use-container-size.js";
import { useChatAction as he } from "./embedded-chat/use-chat-action.js";
import { useHelpMenuState as Ve, HelpMenuProvider as Ue, useHelpMenu as Ke } from "../providers/help-menu-provider.js";
import { useChatForm as b } from "../providers/chat-form-provider.js";
import { FormFieldProvider as qe, useFormField as H } from "../providers/form-field-provider.js";
import { Controller as je } from "react-hook-form";
import { highlightEmphasis as Ge } from "../utils/highlight-emphasis.js";
import { useModal as Fe } from "./modal/modal-provider.js";
import { useColorModeValue as ze } from "@inkeep/cxkit-color-mode";
import { useComposedRefs as ue } from "../utils/compose-refs.js";
import { composeEventHandlers as h } from "../utils/compose-event-handlers.js";
import { useScrollToBottom as Ye } from "../hooks/use-scroll-to-bottom.js";
import { logConversation as Je } from "../atoms/api/analytics/conversation.js";
import { transformInkeepSource as Xe } from "../utils/transform-source/index.js";
const Ze = "__intro__", et = i("div", {
  _id: "aiChatWrapper"
}), ja = Q((t, e) => {
  const { ...a } = t, { isHidden: s, isMobile: r } = g(), [o, c] = Qe(), d = ue(e, o), m = c?.width ? c.width > 580 : !0, l = Fe();
  return /* @__PURE__ */ n(
    et,
    {
      ref: d,
      "data-widget-md": v(m),
      "data-hidden": v(s),
      "data-in-modal": v(!!l),
      "data-mobile": v(r),
      ...a
    }
  );
}), tt = i("div", {
  _id: "aiChatConversationLoading"
}), Ga = (t) => {
  const { isLoadingConversation: e } = g();
  return e ? /* @__PURE__ */ n(tt, { children: /* @__PURE__ */ n("span", { children: "Loading..." }), ...t }) : null;
}, it = i("div", {
  _id: "aiChatRoot"
}), za = (t) => {
  const { isLoadingConversation: e, isHidden: a } = g(), { form: s } = b();
  return e || s ? null : /* @__PURE__ */ n(it, { "data-hidden": v(a), ...t });
}, Ya = i("div", {
  _id: "aiChatHeader"
}), Ja = i("div", {
  _id: "aiChatHeader__Toolbar"
}), Xa = i("div", {
  _id: "aiChatHeader__ToolbarHeaderWrapper"
}), at = i("div", {
  _id: "aiChatHeader__ToolbarHeader"
}), Za = F(
  (t) => {
    const { aiChatSettings: e } = u(), a = `Ask ${e.aiAssistantName || "AI"}`;
    return /* @__PURE__ */ n(at, { ...t, children: a });
  }
), en = i("div", {
  _id: "aiChatContent"
}), tn = i(x.Root, {
  _id: "aiChatContentScrollArea"
}), nt = i(x.Viewport, {
  _id: "aiChatContentScrollArea__Viewport"
}), an = Q(({ children: t, ...e }, a) => {
  const { containerRef: s } = Ye(), r = ue(a, s);
  return /* @__PURE__ */ n(
    nt,
    {
      ref: r,
      children: (
        /* added this to fix an overflow issue see https://github.com/radix-ui/primitives/issues/926 */
        /* @__PURE__ */ n("div", { "data-part": "grid", style: { display: "grid" }, children: t })
      ),
      ...e
    }
  );
}), nn = i(
  x.ScrollAreaScrollbar,
  {
    _id: "aiChatContentScrollArea__Scrollbar"
  }
), sn = i(
  x.ScrollAreaThumb,
  {
    _id: "aiChatContentScrollArea__Thumb"
  }
), rn = i(x.Corner, {
  _id: "aiChatContentScrollArea__Corner"
}), st = i("div", {
  _id: "aiChatMessages"
}), on = (t) => {
  const e = g(), { children: a, ...s } = t;
  return /* @__PURE__ */ n(st, { children: I(a, e), ...s });
}, rt = i("div", {
  _id: "aiChatDisclaimer"
}), cn = F(
  (t) => {
    const { aiChatSettings: e } = u();
    return e.disclaimerSettings?.isEnabled ? /* @__PURE__ */ n(K.Root, { openDelay: 100, children: /* @__PURE__ */ n(rt, { ...t }) }) : null;
  }
), ot = i("span", {
  _id: "aiChatDisclaimerLabel"
}), dn = F(
  (t) => {
    const { aiChatSettings: e } = u(), a = e.disclaimerSettings;
    return /* @__PURE__ */ n(ot, { children: a?.label, ...t });
  }
), mn = i(K.Trigger, {
  _id: "aiChatDisclaimerTrigger",
  children: /* @__PURE__ */ n(A, { iconKey: "info" })
}), ct = i(K.Content, {
  _id: "aiChatDisclaimerContent"
}), ln = (t) => /* @__PURE__ */ n(
  ct,
  {
    side: "top",
    sideOffset: 8,
    align: "end",
    alignOffset: -10,
    ...t
  }
), dt = i(ce, {
  _id: "aiChatDisclaimerText"
}), hn = F(
  (t) => {
    const { aiChatSettings: e } = u(), a = e.aiAssistantName, r = e.disclaimerSettings?.tooltip || `Information provided by ${a || "this AI assistant"} is not guaranteed to be accurate or comprehensive.`;
    return /* @__PURE__ */ n(dt, { shouldOpenLinksInNewTab: !0, children: r, ...t });
  }
), un = i(K.Arrow, {
  _id: "aiChatDisclaimerArrow"
}), mt = i("div", {
  _id: "aiChatExampleQuestions"
}), Cn = (t) => {
  const { aiChatSettings: e } = u(), { messages: a } = g();
  return !e.exampleQuestions?.length || a.length ? null : /* @__PURE__ */ n(mt, { ...t });
}, lt = i("h3", {
  _id: "aiChatExampleQuestionsLabel"
}), pn = F(
  (t) => {
    const { aiChatSettings: e } = u();
    return /* @__PURE__ */ n(lt, { children: e.exampleQuestionsLabel, ...t });
  }
), ht = i("div", {
  _id: "aiChatExampleQuestionsList"
}), vn = F(
  (t) => {
    const { aiChatSettings: e } = u(), a = e.exampleQuestions, { children: s, ...r } = t;
    return /* @__PURE__ */ n(ht, { children: I(s, a), ...r });
  }
), ut = i("div", {
  _id: "aiChatExampleQuestion"
}), gn = Q((t, e) => {
  const { aiChatSettings: a } = u(), s = a.isFirstExampleQuestionHighlighted;
  return /* @__PURE__ */ n(ut, { ref: e, "data-highlight": v(s), ...t });
}), Ct = i("button", {
  _id: "aiChatExampleQuestionButton"
}), _n = (t) => {
  const { question: e, onClick: a, ...s } = t, { handleSubmit: r } = g();
  return /* @__PURE__ */ n(
    Ct,
    {
      onClick: h(a, () => r(e)),
      children: e,
      ...s
    }
  );
}, pt = i("div", {
  _id: "aiChatWorkflows"
}), bn = (t) => {
  const { aiChatSettings: e } = u(), { messages: a } = g();
  return !e.workflows?.length || a.length ? null : /* @__PURE__ */ n(pt, { ...t });
}, vt = i("h3", {
  _id: "aiChatWorkflowsLabel"
}), An = F((t) => {
  const { aiChatSettings: e } = u();
  return /* @__PURE__ */ n(vt, { children: e.workflowsHeader, ...t });
}), gt = i("div", {
  _id: "aiChatWorkflowsList"
}), Pn = F(
  (t) => {
    const { aiChatSettings: e } = u(), a = e.workflows, { children: s, ...r } = t;
    return /* @__PURE__ */ n(gt, { children: I(s, a), ...r });
  }
), _t = i("button", {
  _id: "aiChatWorkflow"
}), Fn = (t) => {
  const { workflow: e, onClick: a, ...s } = t, { handleWorkflow: r } = g();
  return /* @__PURE__ */ n(
    _t,
    {
      onClick: h(a, () => r(e)),
      children: e.displayName,
      ...s
    }
  );
}, bt = i(Ee, {
  _id: "aiChatWorkflow__Icon"
}), Mn = (t) => /* @__PURE__ */ n(bt, { ...t }), At = i("div", {
  _id: "aiChatMessageWrapper"
}), Pt = (t) => {
  const { message: e, ...a } = t;
  return e.role === "system" ? null : /* @__PURE__ */ n(De, { message: e, children: /* @__PURE__ */ n(At, { "data-role": e.role, ...a }) });
}, In = F(
  (t) => {
    const { message: e, ...a } = t, { aiChatSettings: s, baseSettings: r } = u(), o = s.aiAssistantName, c = o ? `Hi, I'm ${o}!` : "Hi!", d = s.chatSubjectName ?? r.organizationDisplayName, m = `${c} 

 I'm an AI assistant trained on documentation, help articles, and other content.`, l = d ? `

 Ask me anything about \`${d}\`.` : `

 Let me know how I can help.`, p = {
      content: s.introMessage ?? `${m}${l}`,
      id: Ze,
      ...e,
      role: "assistant",
      links: []
    };
    return /* @__PURE__ */ n(Pt, { message: p, ...a });
  }
), Ft = i("div", {
  _id: "aiChatMessageHeader"
}), fn = (t) => {
  const { message: e } = _();
  return /* @__PURE__ */ n(Ft, { "data-role": e.role, ...t });
}, Mt = i("div", {
  _id: "aiChatMessageLoading"
}), Sn = (t) => {
  const { isLoading: e, isStreaming: a, messages: s } = g(), { message: r } = _();
  return !(s.at(-1)?.id === r?.id) || r.role !== "assistant" || !e || a ? null : /* @__PURE__ */ n(Mt, { children: "Thinking...", ...t });
}, It = i("div", {
  _id: "aiChatMessageAvatar"
}), En = (t) => {
  const { message: e } = _();
  return /* @__PURE__ */ n(It, { "data-role": e.role, ...t });
}, ft = i(ie.Root, {
  _id: "aiChatMessageAvatarContent"
}), kn = (t) => {
  const { message: e } = _(), { baseSettings: a } = u();
  return /* @__PURE__ */ n(
    ft,
    {
      "data-username": v(e.role === "user" && !!a.userProperties.name),
      "data-role": e.role,
      ...t
    }
  );
}, St = i(ie.Fallback, {
  _id: "aiChatMessageAvatarFallback"
}), Bn = F(
  (t) => {
    const { baseSettings: e } = u(), { message: a } = _();
    return e.userProperties.name ? /* @__PURE__ */ n(
      St,
      {
        "data-role": a.role,
        children: Ne(e.userProperties.name),
        ...t
      }
    ) : null;
  }
), ge = i(ie.Image, {
  _id: "aiChatMessageAvatarImage"
}), Tn = F(
  (t) => {
    const { onLoadingStatusChange: e, ...a } = t, {
      aiChatSettings: s,
      baseSettings: { userProperties: r }
    } = u(), { message: o } = _(), { aiAssistantAvatar: c } = s ?? {}, d = typeof c == "string" ? c : c?.light, m = (typeof c == "string" ? c : c?.dark) ?? d, l = ze(d, m), [C, p] = fe(l);
    be(() => {
      p(l);
    }, [l]);
    const P = (T) => {
      T === "error" && p(null);
    };
    return o.role === "user" ? r.name ? null : s.userAvatar ? /* @__PURE__ */ n(
      ge,
      {
        "data-type": "image",
        "data-role": o.role,
        src: s.userAvatar,
        ...t
      }
    ) : /* @__PURE__ */ n(
      Te,
      {
        "data-type": "icon",
        "data-role": o.role,
        ...t
      }
    ) : C ? /* @__PURE__ */ n(
      ge,
      {
        src: C,
        "data-type": "image",
        "data-role": o.role,
        onLoadingStatusChange: h(
          e,
          P
        ),
        ...a
      }
    ) : /* @__PURE__ */ n(
      Be,
      {
        "data-type": "icon",
        "data-role": o.role,
        ...t
      }
    );
  }
), Et = i("span", {
  _id: "aiChatMessageName"
}), yn = (t) => {
  const { message: e } = _();
  return /* @__PURE__ */ n(
    Et,
    {
      "data-role": e.role,
      children: e.role === "user" ? "You" : "AI assistant",
      ...t
    }
  );
}, kt = i("div", {
  _id: "aiChatMessageContentWrapper"
}), wn = (t) => {
  const { message: e } = _();
  return /* @__PURE__ */ n(kt, { "data-role": e.role, ...t });
}, Bt = i("div", {
  _id: "aiChatMessageContent"
}), Hn = (t) => {
  const { message: e } = _();
  return /* @__PURE__ */ n(Bt, { "data-role": e.role, ...t });
}, Tt = i("div", {
  _id: "aiChatMessageAttachments"
}), Ln = (t) => {
  const { message: e } = _(), a = e.metadata?.attributes?.attachments;
  return e.role !== "user" || !a?.length ? null : /* @__PURE__ */ n(xe, { children: /* @__PURE__ */ n(Tt, { ...t }) });
}, yt = i("div", {
  _id: "aiChatMessageAttachments__List"
}), xn = (t) => {
  const { children: e, ...a } = t, { message: s } = _(), r = s.metadata?.attributes?.attachments;
  return r ? /* @__PURE__ */ n(yt, { children: I(e, r), ...a }) : null;
}, wt = i("div", {
  _id: "aiChatMessageAttachments__Item"
}), Dn = (t) => {
  const { attachment: e, onClick: a, ...s } = t, { selectItem: r, onOpen: o } = G();
  return /* @__PURE__ */ n(Ae, { attachment: e, children: /* @__PURE__ */ n(
    wt,
    {
      onClick: h(a, () => {
        r(e), o();
      }),
      ...s
    }
  ) });
}, Ht = i(B, {
  _id: "aiChatMessageAttachments__ItemIcon"
}), On = (t) => {
  const { attachment: e } = D(), a = e.contentType?.attachmentIcon;
  return a ? /* @__PURE__ */ n(Ht, { iconSettings: a, ...t }) : null;
}, Lt = i("span", {
  _id: "aiChatMessageAttachments__ItemTitle"
}), Wn = (t) => {
  const { attachment: e } = D();
  return /* @__PURE__ */ n(Lt, { children: e.title, ...t });
}, xt = i(oe, {
  _id: "aiChatMessageAttachmentsPreview"
}), Nn = (t) => {
  const { onOpenChange: e, ...a } = t, { selectItem: s, isOpen: r, onClose: o, selectedItem: c } = G();
  return /* @__PURE__ */ n(
    xt,
    {
      open: r && c !== null,
      onOpenChange: h(e, (m) => {
        m || (o(), s(null));
      }),
      ...a
    }
  );
}, Rn = i(ae, {
  _id: "aiChatMessageAttachmentsPreview__Overlay"
}), $n = i(ne, {
  _id: "aiChatMessageAttachmentsPreview__Content",
  "aria-describedby": void 0
}), Dt = i(re, {
  _id: "aiChatMessageAttachmentsPreview__Header"
}), Qn = (t) => {
  const { selectedItem: e } = G();
  return /* @__PURE__ */ n(
    Dt,
    {
      children: e?.title || "Attachment",
      ...t
    }
  );
}, Vn = i(se, {
  _id: "aiChatMessageAttachmentsPreview__Close",
  children: /* @__PURE__ */ n(A, { iconKey: "close" })
}), Ot = i("p", {
  _id: "aiChatMessageAttachmentsPreview__Body"
}), Un = (t) => {
  const { selectedItem: e } = G();
  return /* @__PURE__ */ n(Ot, { children: e?.content, ...t });
}, _e = i("div", {
  _id: "aiChatMessage"
}), Kn = (t) => {
  const { aiChatSettings: e } = u(), { componentStyles: a, ...s } = t, { message: r } = _(), { logEvent: o } = j(), c = le(r), { conversation: d } = q();
  return r.role === "user" ? /* @__PURE__ */ n(_e, { "data-role": r.role, children: c, ...s }) : /* @__PURE__ */ n(_e, { "data-role": r.role, ...s, children: /* @__PURE__ */ n(
    ce,
    {
      children: c,
      componentStyles: a,
      shouldOpenLinksInNewTab: e.shouldOpenLinksInNewTab,
      onLinkClick: (m, l) => {
        o({
          eventName: "assistant_message_inline_link_opened",
          properties: {
            title: l?.toString(),
            url: m
          }
        });
      },
      onCodeCopy: (m, l) => {
        o({
          eventName: "assistant_code_block_copied",
          properties: {
            conversation: d,
            language: m,
            code: l
          }
        });
      }
    }
  ) });
}, Wt = i("div", {
  _id: "aiChatMessageToolbar"
}), qn = (t) => {
  const { isLoading: e, messages: a } = g(), { message: s } = _();
  return a.at(-1)?.id === s?.id && e || s.role === "user" ? null : /* @__PURE__ */ n(Wt, { ...t });
}, Nt = i("div", {
  _id: "aiChatMessageToolActions"
}), jn = (t) => {
  const { children: e, ...a } = t, { message: s } = _(), { messageButtons: r } = g(), o = r[s.id] || [];
  return /* @__PURE__ */ n(Nt, { children: I(e, o), ...a });
}, Gn = (t) => {
  const { onClick: e, action: a, ...s } = t, { handleAction: r } = he(a), o = () => {
    r();
  }, c = a.label || "Contact Support", d = /* @__PURE__ */ $(ee, { children: [
    a.icon && /* @__PURE__ */ n(B, { iconSettings: a.icon }),
    c
  ] }), m = a.action.type, l = i(m === "open_link" ? "a" : "button", {
    _id: "aiChatMessageToolAction",
    children: d,
    "data-type": a.action.type,
    ...m === "open_link" && {
      href: a.action.url,
      target: "_blank",
      rel: "noopener"
    },
    onClick: h(e, o)
  });
  return /* @__PURE__ */ n(l, { ...s });
}, Rt = i("button", {
  _id: "aiChatMessageAction"
}), zn = (t) => {
  const { action: e, onClick: a, className: s, ...r } = t, { conversation: o } = q(), { message: c } = _(), { isStreaming: d, messages: m } = g(), [l, C] = Z(), { feedback: p, submitPositiveFeedback: P, setCurrentFeedback: T, currentFeedback: O } = de(), { logEvent: z } = j(), [W, Y] = $e(), {
    baseSettings: { privacyPreferences: Ce }
  } = u(), { optOutAllAnalytics: J } = Ce, pe = m.at(-1)?.id === c?.id, X = c.role === "assistant";
  if (pe && d || !X || {
    copy: !1,
    upvote: J,
    downvote: J
  }[e]) return null;
  const y = {
    copy() {
      C(le(c)), z({
        eventName: "assistant_message_copied",
        properties: {
          conversation: o
        }
      });
    },
    upvote() {
      P(c.id).then(() => {
        Y();
      });
    },
    downvote() {
      T(c.id);
    }
  }, L = {
    copy: "Copy Message",
    upvote: "Upvote Message",
    downvote: "Downvote Message"
  }, S = {
    copy: /* @__PURE__ */ n(A, { iconKey: l ? "messageCopied" : "messageCopy" }),
    upvote: /* @__PURE__ */ n(A, { iconKey: W ? "messageCopied" : "thumbsUp" }),
    downvote: /* @__PURE__ */ n(A, { iconKey: "thumbsDown" })
  }, E = {
    copy: { "data-copied": v(l) },
    upvote: {
      "data-upvoted": v(p[c.id]?.type === "positive")
    },
    downvote: {
      "data-downvoted": v(p[c.id]?.type === "negative"),
      "data-state": O === null ? "closed" : "open"
    }
  };
  return /* @__PURE__ */ n(
    Rt,
    {
      "data-action": e,
      ...E[e],
      children: S[e],
      "aria-label": L[e],
      className: `${s} ${e}`,
      onClick: h(a, y[e]),
      ...r
    }
  );
}, $t = i("div", {
  _id: "aiChatMessageSources"
}), Yn = (t) => {
  const { message: e } = _();
  return e.role !== "assistant" || !e.links?.length ? null : /* @__PURE__ */ n($t, { ...t });
}, Qt = i("div", {
  _id: "aiChatMessageSources__Header"
}), Jn = (t) => /* @__PURE__ */ n(Qt, { children: "Sources", ...t }), Vt = i("div", {
  _id: "aiChatMessageSources__List"
}), Xn = (t) => {
  const { message: e } = _(), { children: a, ...s } = t, {
    baseSettings: { transformSource: r, organizationDisplayName: o },
    aiChatSettings: { shouldOpenLinksInNewTab: c },
    searchSettings: { tabs: d }
  } = u();
  if (e.role !== "assistant") return null;
  const m = e.links.map((l) => {
    const C = Xe(l, "chatSourceItem", {
      organizationDisplayName: o,
      tabs: d,
      transformSource: r
    }), p = C.shouldOpenInNewTab !== void 0 ? C.shouldOpenInNewTab : c;
    return { ...C, isExternal: p };
  });
  return /* @__PURE__ */ n(Vt, { children: I(a, m), ...s });
}, Ut = i(ye, {
  _id: "aiChatMessageSourceItem"
}), Zn = (t) => {
  const { source: e, onClick: a, ...s } = t, { logEvent: r } = j(), { conversation: o } = q(), c = () => {
    r({
      eventName: "assistant_source_item_clicked",
      properties: {
        conversation: o,
        link: e
      }
    });
  };
  return /* @__PURE__ */ n(He, { source: e, children: /* @__PURE__ */ n(
    Ut,
    {
      "data-type": e.type,
      appendToUrl: e.appendToUrl,
      isExternal: e.isExternal,
      "data-breadcrumbs": !!e.breadcrumbs?.length,
      onClick: h(a, c),
      ...s
    }
  ) });
}, Kt = i("div", {
  _id: "aiChatMessageSourceItem__Breadcrumbs"
}), es = (t) => {
  const { source: e } = w();
  return e.breadcrumbs?.length ? /* @__PURE__ */ n(Kt, { "data-type": e.type, ...t }) : null;
}, ts = i(A, {
  _id: "aiChatMessageSourceItem__BreadcrumbIcon",
  iconKey: "breadcrumbSeparator"
}), qt = i(B, {
  _id: "aiChatMessageSourceItem__Icon"
}), is = (t) => {
  const { source: e } = w();
  return /* @__PURE__ */ n(qt, { iconSettings: e.icon, "data-type": e.type, ...t });
}, jt = i("span", {
  _id: "aiChatMessageSourceItem__Title"
}), as = (t) => {
  const { source: e } = w();
  return /* @__PURE__ */ n(jt, { "data-type": e.type, children: e.title, ...t });
}, Gt = i("span", {
  _id: "aiChatMessageSourceItem__Tag"
}), ns = (t) => {
  const { source: e } = w();
  return /* @__PURE__ */ n(Gt, { "data-type": e.type, ...t });
}, zt = i("span", {
  _id: "aiChatMessageSourceItem__Description"
}), ss = (t) => {
  const { source: e } = w(), { children: a, ...s } = t, r = Se(() => e.description ? Ge(e.description) : [], [e.description]);
  return r.length ? /* @__PURE__ */ n(
    zt,
    {
      "data-type": e.type,
      children: I(a, r),
      ...s
    }
  ) : null;
}, Yt = i("span", {
  _id: "aiChatMessageSourceItem__DescriptionPart"
}), rs = (t) => {
  const { part: e, ...a } = t, { source: s } = w();
  return typeof e == "string" ? e : /* @__PURE__ */ n(
    Yt,
    {
      "data-type": s.type,
      children: e.content,
      "data-highlighted": v(e.highlighted),
      ...a
    }
  );
}, Jt = i(A, {
  _id: "aiChatMessageSourceItem__Indicator"
}), os = (t) => {
  const { source: e } = w();
  return /* @__PURE__ */ n(
    Jt,
    {
      iconKey: e.isExternal ? "openLinkInNewTab" : "openLinkInSameTab",
      ...t
    }
  );
}, cs = i("div", {
  _id: "aiChatFooter"
}), ds = i("div", {
  _id: "aiChatInput__Fieldset"
}), ms = i("div", {
  _id: "aiChatInput__Group"
}), Xt = i("textarea", {
  _id: "aiChatInput"
}), ls = Q(({ onChange: t, onKeyDown: e, ...a }, s) => {
  const { handleInputChange: r, handleInputKeyDown: o, input: c, error: d, shouldAutoFocusInput: m, inputRef: l } = g(), { aiChatSettings: C } = u(), p = ue(
    s,
    l
  ), P = Fe();
  return be(() => {
    requestAnimationFrame(() => {
      m && l?.current && (l.current.focus(), l.current.selectionStart = l.current.value.length);
    });
  }, [m, l, P?.isOpen]), /* @__PURE__ */ n(
    Xt,
    {
      asChild: !0,
      ref: p,
      maxLength: 99999,
      placeholder: C.placeholder,
      value: c,
      onChange: h(t, r),
      onKeyDown: h(e, o),
      disabled: !!d || C.isViewOnly,
      ...a,
      children: /* @__PURE__ */ n(te, {})
    }
  );
}), Zt = i("button", {
  _id: "aiChatInput__SendButton"
}), hs = (t) => {
  const { handleSubmit: e, isSubmitDisabled: a, error: s } = g(), { aiChatSettings: r } = u(), { onClick: o, ...c } = t;
  return /* @__PURE__ */ n(
    Zt,
    {
      onClick: h(o, () => e()),
      "aria-label": "Send message",
      disabled: a || !!s || r.isViewOnly,
      ...c
    }
  );
}, us = i(A, {
  _id: "aiChatInput__SendButtonIcon",
  iconKey: "chatSubmit"
}), ei = i("div", {
  _id: "aiChatAttachmentsBar"
}), Cs = (t) => {
  const { selectedWorkflow: e } = g();
  return !e || !e.supportedInputs?.length ? null : /* @__PURE__ */ n(we, { children: /* @__PURE__ */ n(ei, { ...t }) });
}, ti = i("div", {
  _id: "aiChatAttachmentsBar__List"
}), ps = (t) => {
  const { children: e, ...a } = t, { messageAttachments: s } = g();
  return /* @__PURE__ */ n(ti, { children: I(e, s), ...a });
}, ii = i("div", {
  _id: "aiChatAttachmentsBar__Attachment"
}), vs = (t) => {
  const { attachment: e, ...a } = t;
  return /* @__PURE__ */ n(Ae, { attachment: e, children: /* @__PURE__ */ n(ii, { ...a }) });
}, ai = i(B, {
  _id: "aiChatAttachmentsBar__AttachmentIcon"
}), gs = (t) => {
  const { attachment: e } = D(), a = e.contentType?.attachmentIcon;
  return a ? /* @__PURE__ */ n(ai, { iconSettings: a, ...t }) : null;
}, ni = i("span", {
  _id: "aiChatAttachmentsBar__AttachmentTitle"
}), _s = (t) => {
  const { attachment: e } = D();
  return /* @__PURE__ */ n(ni, { children: e.title, ...t });
}, si = i("button", {
  _id: "aiChatAttachmentsBar__AttachmentDelete"
}), bs = (t) => {
  const { onClick: e, ...a } = t, { attachment: s } = D(), { setMessageAttachments: r } = g();
  return /* @__PURE__ */ n(
    si,
    {
      "aria-label": "Remove attachment",
      children: /* @__PURE__ */ n(A, { iconKey: "close" }),
      onClick: h(e, () => {
        r((c) => c.filter((d) => d.id !== s.id));
      }),
      ...a
    }
  );
}, As = i("div", {
  _id: "aiChatAttachmentsBar__Actions"
}), Ps = i(k.Tooltip, {
  _id: "aiChatAttachmentsBar__InfoTip",
  delayDuration: 0
}), Fs = i(k.Trigger, {
  _id: "aiChatAttachmentsBar__InfoTipIcon",
  children: /* @__PURE__ */ n(A, { iconKey: "info" })
}), ri = i(k.Arrow, {
  _id: "aiChatAttachmentsBar__InfoTipArrow"
}), Ms = i(k.Content, {
  _id: "aiChatAttachmentsBar__InfoTipText",
  side: "bottom",
  sideOffset: 3,
  align: "center",
  children: /* @__PURE__ */ $(ee, { children: [
    /* @__PURE__ */ n(ri, {}),
    "Attachments will be kept in context for the entire conversation."
  ] })
}), oi = i("div", {
  _id: "aiChatAttachmentsBar__Inputs"
}), Is = (t) => {
  const { children: e, ...a } = t, { selectedWorkflow: s } = g();
  return s?.supportedInputs ? /* @__PURE__ */ n(
    oi,
    {
      children: I(e, s.supportedInputs),
      ...a
    }
  ) : null;
}, ci = i("button", {
  _id: "aiChatAttachmentsBar__Input"
}), fs = (t) => {
  const { input: e, onClick: a, ...s } = t, { selectedWorkflow: r, messageAttachments: o, setMessageAttachments: c } = g(), { selectInput: d, onOpen: m } = M(), l = () => {
    if (e.type === "FUNCTIONAL_MULTI_ATTACHMENT")
      return r ? e.onInvoke(r, e, c, [...o]) : void 0;
    d(e), m();
  };
  return /* @__PURE__ */ n(
    ci,
    {
      children: e.displayName,
      onClick: h(a, l),
      ...s
    }
  );
}, Ss = i(ke, {
  _id: "aiChatAttachmentsBar__InputIcon"
}), di = i(oe, {
  _id: "aiChatAttachmentsBar__Modal"
}), Es = (t) => {
  const { onOpenChange: e, ...a } = t, { selectInput: s, isOpen: r, onClose: o, selectedInput: c } = M();
  return /* @__PURE__ */ n(
    di,
    {
      open: r && c !== null,
      onOpenChange: h(e, (m) => {
        m || (o(), s(null));
      }),
      ...a
    }
  );
}, ks = i(ae, {
  _id: "aiChatAttachmentsBar__ModalOverlay"
}), Bs = i(ne, {
  _id: "aiChatAttachmentsBar__ModalContent",
  "aria-describedby": void 0
}), Ts = i("div", {
  _id: "aiChatAttachmentsBar__ModalHeader"
}), mi = i(re, {
  _id: "aiChatAttachmentsBar__ModalHeading"
}), ys = (t) => {
  const { selectedInput: e } = M(), a = `Add ${e?.displayName}`;
  return /* @__PURE__ */ n(mi, { children: a, ...t });
}, li = i("span", {
  _id: "aiChatAttachmentsBar__ModalDescription"
}), ws = (t) => {
  const { selectedInput: e } = M(), a = e?.workflowModalProps?.modalHelpText;
  return a ? /* @__PURE__ */ n(li, { children: a, ...t }) : null;
}, hi = i("div", {
  _id: "aiChatAttachmentsBar__ModalHelp"
}), Hs = (t) => {
  const { children: e, ...a } = t, { selectedInput: s } = M(), r = s?.workflowModalProps?.modalHelpElement;
  return r ? /* @__PURE__ */ n(hi, { asChild: !e, children: e || r, ...a }) : null;
}, Ls = i(se, {
  _id: "aiChatAttachmentsBar__ModalClose",
  children: /* @__PURE__ */ n(A, { iconKey: "close" })
}), xs = i("div", {
  _id: "aiChatAttachmentsBar__ModalBody"
}), ui = i("form", {
  _id: "aiChatAttachmentsBar__Form"
}), Ds = (t) => {
  const { onSubmit: e, ...a } = t, { form: s } = M();
  return /* @__PURE__ */ n(
    ui,
    {
      onSubmit: h(e, s.onSubmit),
      ...a
    }
  );
}, Os = i("div", {
  _id: "aiChatAttachmentsBar__FormTitle",
  role: "group"
}), Ci = i("label", {
  _id: "aiChatAttachmentsBar__FormTitleLabel"
}), Ws = (t) => {
  const { form: e, selectedInput: a } = M();
  return /* @__PURE__ */ n(
    Ci,
    {
      htmlFor: `${a?.id}-title`,
      children: e.labels.title,
      ...t
    }
  );
}, pi = i("input", {
  _id: "aiChatAttachmentsBar__FormTitleInput"
}), Ns = (t) => {
  const { onChange: e, ...a } = t, { form: s, selectedInput: r } = M();
  return /* @__PURE__ */ n(
    pi,
    {
      name: "title",
      value: s.data.title,
      id: `${r?.id}-title`,
      "data-invalid": v(!!s.errors.title),
      "aria-invalid": !!s.errors.title,
      onChange: h(e, s.onChange),
      ...a
    }
  );
}, vi = i("span", {
  _id: "aiChatAttachmentsBar__FormTitleError"
}), Rs = (t) => {
  const { form: e } = M();
  return e.errors.title ? /* @__PURE__ */ n(
    vi,
    {
      "aria-live": "polite",
      children: e.errors.title,
      ...t
    }
  ) : null;
}, $s = i("div", {
  _id: "aiChatAttachmentsBar__FormTitle",
  role: "group"
}), gi = i("label", {
  _id: "aiChatAttachmentsBar__FormContentLabel"
}), Qs = (t) => {
  const { form: e, selectedInput: a } = M();
  return /* @__PURE__ */ n(
    gi,
    {
      htmlFor: `${a?.id}-content`,
      children: e.labels.content,
      ...t
    }
  );
}, _i = i("textarea", {
  _id: "aiChatAttachmentsBar__FormTitleInput"
}), Vs = (t) => {
  const { onChange: e, ...a } = t, { form: s, selectedInput: r } = M();
  return /* @__PURE__ */ n(
    _i,
    {
      asChild: !0,
      rows: 4,
      name: "content",
      value: s.data.content,
      id: `${r?.id}-content`,
      "data-invalid": v(!!s.errors.content),
      "aria-invalid": !!s.errors.content,
      onChange: h(e, s.onChange),
      ...a,
      children: /* @__PURE__ */ n(te, { maxRows: 10 })
    }
  );
}, bi = i("span", {
  _id: "aiChatAttachmentsBar__FormContentError"
}), Us = (t) => {
  const { form: e } = M();
  return e.errors.content ? /* @__PURE__ */ n(
    bi,
    {
      "aria-live": "polite",
      children: e.errors.content,
      ...t
    }
  ) : null;
}, Ks = i("button", {
  _id: "aiChatAttachmentsBar__FormSubmitButton",
  children: "Upload",
  type: "submit"
}), qs = i("div", {
  _id: "aiChatActionBar"
}), js = i("div", {
  _id: "aiChat__ChatActions"
}), Gs = i("div", {
  _id: "aiChatTagline__Container"
}), zs = i("span", {
  _id: "aiChatTagline__Text",
  children: "Powered by"
}), Ys = i(Re, {
  _id: "aiChatTagline__Logo"
}), Js = i("a", {
  _id: "aiChatTagline__BrandName",
  children: "inkeep",
  href: "https://www.inkeep.com/",
  target: "_blank",
  rel: "noopener noreferrer"
}), Ai = i("div", {
  _id: "aiChat__ChatAction"
}), Me = (t) => {
  const { action: e, onClick: a, className: s, ...r } = t, { clear: o, stop: c, isLoading: d, messages: m, selectedWorkflow: l } = g(), { conversation: C } = q(), { aiChatSettings: p, baseSettings: P } = u(), { logEvent: T } = j(), [O, z] = Z(), [W, Y] = Z();
  if ({
    help: !1,
    copy: m.length === 0 || !p.isCopyChatButtonVisible || d,
    share: m.length === 0 || !p.isShareButtonVisible || !C.id || !!l || d,
    clear: m.length === 0 || p.isViewOnly || d,
    stop: !d
  }[e]) return null;
  const X = {
    // Help actions are handled by HelpAction component
    help: () => {
    },
    copy: () => {
      const N = m.map((y) => {
        const L = `**${y.role === "assistant" ? "AI Assistant" : "User"}**`, S = le(y), E = We(y.metadata?.attributes?.attachments), R = E ? `

**Attachments**

${E}` : "";
        return `${L}

${S}${R}`;
      }).join(`

---

`);
      z(N);
    },
    share: async () => {
      const N = {
        visibility: "public",
        tags: [],
        userProperties: {},
        messages: C.messages.map((E) => ({
          ...E,
          createdAt: void 0,
          updatedAt: void 0,
          id: Date.now().toString() + E.id,
          conversationId: void 0
        }))
      }, { apiKey: y, analyticsApiBaseUrl: L } = P, S = await Je(
        "",
        N,
        y,
        L
      );
      if (S) {
        const R = `${p.shareChatUrlBasePath}?${Le}=${S?.id}`;
        Y(R), T({
          eventName: "chat_share_button_clicked",
          properties: {
            sharedConversationId: S?.id,
            originalConversationId: C.id,
            sharedChatUrl: R,
            conversation: S
          }
        });
      }
    },
    clear: o,
    stop: c
  }, ve = {
    copy: O,
    share: W
  };
  return /* @__PURE__ */ n(k.Tooltip, { delayDuration: 0, open: ve[e], children: /* @__PURE__ */ n(
    Ai,
    {
      "data-type": e,
      "data-copied": v(O || W),
      className: `${s} ${e}`,
      children: /* @__PURE__ */ n(Fi, { action: e }),
      onClick: h(a, X[e]),
      ...r
    }
  ) });
}, Pi = i(k.Trigger, {
  _id: "aiChat__ChatActionLabel"
}), Fi = (t) => {
  const { action: e, ...a } = t, { aiChatSettings: s } = u(), r = s.toolbarButtonLabels ?? {}, o = {
    help: r.getHelp ?? "Get Help",
    copy: r.copyChat ?? "Copy",
    share: r.share ?? "Share",
    clear: r.clear ?? "Clear",
    stop: r.stop ?? "Stop"
  };
  return /* @__PURE__ */ n(Pi, { children: o[e], ...a });
}, Mi = i(k.TooltipContent, {
  _id: "aiChat__ChatActionFeeback"
}), Xs = (t) => {
  const { action: e, children: a, ...s } = t, r = {
    copy: "Copied!",
    share: "Link copied!"
  };
  return /* @__PURE__ */ $(Mi, { sideOffset: 5, ...s, children: [
    /* @__PURE__ */ n(k.Arrow, {}),
    a || r[e]
  ] });
}, Ii = i(U.Root, {
  _id: "aiChatHelpActions"
}), Zs = (t) => {
  const { children: e, ...a } = t, { aiChatSettings: s } = u(), { getHelpOptions: r } = s;
  if (!r || (r ?? []).length === 0)
    return null;
  const { _pinned: o, _unpinned: c } = r.reduce(
    (C, p) => {
      const P = p.isPinnedToToolbar ? "_pinned" : "_unpinned";
      return { ...C, [P]: [...C[P], p] };
    },
    { _pinned: [], _unpinned: [] }
  ), d = c.length === 1 ? [...o, c[0]] : o, m = c.length === 1 ? [] : c, l = Ve();
  return /* @__PURE__ */ n(Ue, { value: l, children: /* @__PURE__ */ n(
    Ii,
    {
      open: l.open,
      onOpenChange: l.setOpen,
      children: I(e, { pinned: d, unpinned: m }),
      ...a
    }
  ) });
}, fi = i(Me, {
  _id: "aiChatHelpAction",
  action: "help"
}), Si = i("a", {
  _id: "aiChatHelpAction",
  target: "_blank",
  rel: "noreferrer"
}), er = (t) => {
  const { action: e, onClick: a, ...s } = t, { handleAction: r, logHelpAction: o } = he(e), c = e.action.type, d = {
    "aria-label": e.name,
    "data-name": e.name,
    children: e.name,
    onClick: h(a, () => {
      r(), o();
    }),
    // biome-ignore lint/suspicious/noExplicitAny: <explanation>
    ...s
  };
  return c === "open_link" ? /* @__PURE__ */ n(Si, { href: e.action.url, ...d }) : /* @__PURE__ */ n(fi, { ...d });
}, Ei = i(U.Trigger, {
  _id: "aiChatHelpActions__Trigger"
}), tr = F(
  (t) => {
    const { aiChatSettings: e } = u();
    return /* @__PURE__ */ n(Me, { action: "help", ...t, asChild: !0, children: /* @__PURE__ */ n(Ei, { children: e.toolbarButtonLabels?.getHelp ?? "Get Help" }) });
  }
), ki = i(U.Content, {
  _id: "aiChatHelpActions__Menu"
}), ir = (t) => /* @__PURE__ */ n(
  ki,
  {
    side: "top",
    sideOffset: 8,
    align: "center",
    alignOffset: -10,
    ...t
  }
), ar = i(U.Arrow, {
  _id: "aiChatHelpActions__MenuArrow"
}), nr = (t) => {
  const { action: e, onClick: a, ...s } = t, { handleAction: r, logHelpAction: o } = he(e), { setOpen: c } = Ke(), d = () => {
    r({
      onOpenForm: () => c(!1)
    }), o();
  }, m = e.action.type, l = i(m === "open_link" ? "a" : "button", {
    _id: "aiChatHelpActions__MenuItem",
    children: e.name,
    "aria-label": e.name,
    "data-name": e.name,
    "data-type": e.action.type,
    ...m === "open_link" && {
      href: e.action.url,
      target: "_blank",
      rel: "noopener"
    },
    onClick: h(a, d)
  });
  return /* @__PURE__ */ n(l, { ...s });
}, Bi = i(B, {
  _id: "aiChatHelpActions_MenuItemIcon"
}), sr = (t) => {
  const { action: e, ...a } = t;
  return e.icon ? /* @__PURE__ */ n(Bi, { iconSettings: e.icon, ...a }) : null;
}, Ti = i(oe, {
  _id: "aiChatFeedbackModal"
}), rr = (t) => {
  const { onOpenChange: e, ...a } = t, { currentFeedback: s, setCurrentFeedback: r } = de();
  return /* @__PURE__ */ n(
    Ti,
    {
      open: s !== null,
      onOpenChange: h(e, () => r(null)),
      ...a
    }
  );
}, or = i(ae, {
  _id: "aiChatFeedbackModal__Overlay"
}), cr = i(ne, {
  _id: "aiChatFeedbackModal__Content",
  "aria-describedby": void 0
}), dr = i(re, {
  _id: "aiChatFeedbackModal__Header",
  children: "Help improve my answers!"
}), mr = i(se, {
  _id: "aiChatFeedbackModal__Close",
  children: /* @__PURE__ */ n(A, { iconKey: "close" })
}), lr = i("div", {
  _id: "aiChatFeedbackModal__Body"
}), yi = i("form", {
  _id: "aiChatFeedbackForm"
}), hr = (t) => {
  const { onSubmit: e, ...a } = t, { submitNegativeFeedback: s, currentFeedback: r, setCurrentFeedback: o } = de();
  return /* @__PURE__ */ n(yi, { onSubmit: h(e, (d) => {
    d.preventDefault();
    const m = d.target, l = new FormData(m), C = Object.fromEntries(l.entries());
    r && (s(r, C), o(null));
  }), ...a });
}, wi = i("div", {
  _id: "aiChatFeedbackItem"
}), ur = (t) => {
  const { name: e, ...a } = t;
  return /* @__PURE__ */ n(Oe, { name: e, children: /* @__PURE__ */ n(wi, { ...a }) });
}, Hi = i(V.Root, {
  _id: "aiChatFeedbackItem__Checkbox"
}), Cr = (t) => {
  const { name: e, focusItem: a } = me(), { onCheckedChange: s, ...r } = t, o = (c) => {
    c && a?.current?.focus();
  };
  return /* @__PURE__ */ n(
    Hi,
    {
      id: `feedback-${e}`,
      name: e,
      onCheckedChange: h(s, o),
      ...r
    }
  );
}, pr = i(V.Indicator, {
  _id: "aiChatFeedbackItem__CheckboxIndicator",
  children: /* @__PURE__ */ n(Pe, {})
}), Li = i("label", {
  _id: "aiChatFeedbackItem__Label"
}), vr = (t) => {
  const { name: e } = me(), a = {
    unrelated_response: "Didn't answer my question",
    inaccurate_statement: "Inaccurate statement",
    inaccurate_code_snippet: "Inaccurate code snippet",
    irrelevant_citations: "Irrelevant citations"
  };
  return /* @__PURE__ */ n(Li, { htmlFor: `feedback-${e}`, children: a[e], ...t });
}, xi = i("textarea", {
  _id: "aiChatFeedbackItem__Description",
  placeholder: "Please describe"
}), gr = (t) => {
  const { name: e, focusItem: a } = me();
  return /* @__PURE__ */ n(
    xi,
    {
      ref: a,
      name: `${e}:description`,
      ...t
    }
  );
}, _r = i("button", {
  _id: "aiChatFeedbackForm__SubmitButton",
  children: "Submit",
  type: "submit"
}), Di = i("div", {
  _id: "aiChatForm__Wrapper"
}), br = (t) => {
  const { form: e } = b();
  return e ? /* @__PURE__ */ n(Di, { ...t }) : null;
}, Oi = i("form", {
  _id: "aiChatForm"
}), Ar = (t) => {
  const { onSubmit: e, ...a } = t, { handleSubmit: s, isSuccess: r } = b();
  return r ? null : /* @__PURE__ */ n(Oi, { onSubmit: h(e, s), ...a });
}, Wi = i("button", {
  _id: "aiChatForm__Close",
  children: /* @__PURE__ */ n(A, { iconKey: "close" })
}), Pr = (t) => {
  const { onClick: e, ...a } = t, { closeForm: s } = b();
  return /* @__PURE__ */ n(Wi, { onClick: h(e, s), ...a });
}, Fr = i("div", {
  _id: "aiChatForm__Header"
}), Ni = i("h2", {
  _id: "aiChatForm__Heading"
}), Mr = (t) => {
  const { form: e } = b();
  return e?.heading ? /* @__PURE__ */ n(Ni, { children: e.heading, ...t }) : null;
}, Ri = i("span", {
  _id: "aiChatForm__Description"
}), Ir = (t) => {
  const { form: e } = b();
  return e?.description ? /* @__PURE__ */ n(Ri, { children: e.description, ...t }) : null;
}, $i = i("div", {
  _id: "aiChatForm__Content"
}), fr = (t) => {
  const { children: e, ...a } = t, { fields: s = [] } = b();
  return /* @__PURE__ */ n($i, { children: I(e, s), ...a });
}, Qi = i("div", {
  _id: "aiChatForm__Field"
}), Sr = (t) => {
  const { field: e, autoFocus: a, ...s } = t, { control: r, errors: o } = b();
  return /* @__PURE__ */ n(
    je,
    {
      name: e.name,
      control: r,
      rules: { required: e.isRequired ? `${e.label} is required.` : void 0 },
      render: ({ field: c }) => {
        const d = c.value !== void 0 || e.inputType === "file";
        return /* @__PURE__ */ n(
          qe,
          {
            "data-invalid": v(!!o[e.name]),
            field: e,
            fieldProps: c,
            autoFocus: a,
            children: d && /* @__PURE__ */ n(
              Qi,
              {
                "data-input-type": e.inputType,
                "data-hidden": v(e.isHidden),
                ...s
              }
            )
          }
        );
      }
    }
  );
}, Vi = i("label", {
  _id: "aiChatForm__FieldLabel"
}), Er = (t) => {
  const { field: e } = H();
  return /* @__PURE__ */ n(
    Vi,
    {
      "data-required": v(e.isRequired),
      htmlFor: e.name,
      children: e.label,
      ...t
    }
  );
}, Ui = i("input", {
  _id: "aiChatForm__FieldText",
  type: "text"
}), Ie = (t) => {
  const {
    field: e,
    error: a,
    fieldProps: { onChange: s, onBlur: r, ...o },
    autoFocus: c
  } = H(), { onChange: d, onBlur: m, ...l } = t;
  return /* @__PURE__ */ n(
    Ui,
    {
      id: e.name,
      autoFocus: c,
      placeholder: "placeholder" in e ? e.placeholder : void 0,
      "data-invalid": v(!!a),
      onChange: h(d, s),
      onBlur: h(m, r),
      ...o,
      ...l
    }
  );
}, kr = i(Ie, {
  _id: "aiChatForm__FieldEmail",
  type: "email"
}), Ki = i("input", {
  _id: "aiChatForm__FieldFile",
  type: "file",
  multiple: !0
}), Br = (t) => {
  const {
    field: e,
    error: a,
    fieldProps: { value: s, onChange: r, onBlur: o, ...c },
    autoFocus: d
  } = H(), { onChange: m, onBlur: l, ...C } = t, p = (P) => {
    const T = P.target.files;
    r(T);
  };
  return /* @__PURE__ */ n(
    Ki,
    {
      id: e.name,
      autoFocus: d,
      "data-value": s,
      "data-invalid": v(!!a),
      ...C,
      ...c,
      onChange: h(m, p),
      onBlur: h(l, o)
    }
  );
}, Tr = i(Ie, {
  _id: "aiChatForm__FieldTextArea",
  type: "textarea",
  asChild: !0,
  children: /* @__PURE__ */ n(te, { maxRows: 8 })
}), qi = i(V.Root, {
  _id: "aiChatForm__FieldCheckbox"
}), yr = (t) => {
  const { field: e, error: a, fieldProps: s, autoFocus: r } = H(), { onCheckedChange: o, ...c } = t;
  return /* @__PURE__ */ n(
    qi,
    {
      id: e.name,
      name: e.name,
      autoFocus: r,
      "data-invalid": v(!!a),
      checked: s.value,
      onCheckedChange: h(o, s.onChange),
      ...c
    }
  );
}, wr = i(V.Indicator, {
  _id: "aiChatForm__FieldCheckboxIndicator",
  children: /* @__PURE__ */ n(Pe, {})
}), ji = i(f.Root, {
  _id: "aiChatForm__FieldSelect"
}), Hr = (t) => {
  const { field: e, error: a, fieldProps: s } = H(), { onValueChange: r, ...o } = t;
  return /* @__PURE__ */ n(
    ji,
    {
      name: e.name,
      "data-invalid": v(!!a),
      value: s.value,
      onValueChange: h(r, s.onChange),
      ...o
    }
  );
}, Lr = i(f.Trigger, {
  _id: "aiChatForm__FieldSelect__Trigger"
}), Gi = i(f.Value, {
  _id: "aiChatForm__FieldSelect__Value"
}), xr = (t) => {
  const { field: e } = H();
  return /* @__PURE__ */ n(
    Gi,
    {
      placeholder: "placeholder" in e ? e.placeholder : void 0,
      ...t
    }
  );
}, Dr = i(f.Icon, {
  _id: "aiChatForm__FieldSelect__Icon",
  asChild: !0,
  children: /* @__PURE__ */ n(B, { iconSettings: { builtIn: "LuChevronDown" } })
}), Or = i(f.Content, {
  _id: "aiChatForm__FieldSelect__Content",
  position: "popper"
}), Wr = i(f.Viewport, {
  _id: "aiChatForm__FieldSelect__Viewport"
}), Nr = i(f.Item, {
  _id: "aiChatForm__FieldSelect__Item"
}), Rr = i(f.ItemText, {
  _id: "aiChatForm__FieldSelect__ItemText"
}), $r = i(
  f.ItemIndicator,
  {
    _id: "aiChatForm__FieldSelect__ItemIndicator",
    asChild: !0,
    children: /* @__PURE__ */ n(B, { iconSettings: { builtIn: "LuCheck" } })
  }
), zi = i("span", {
  _id: "aiChatForm__FieldError"
}), Qr = (t) => {
  const { error: e } = H();
  return e ? /* @__PURE__ */ n(zi, { children: e.message?.toString(), ...t }) : null;
}, Yi = i("span", {
  _id: "aiChatForm__Error"
}), Vr = (t) => {
  const { formError: e } = b();
  return e ? /* @__PURE__ */ n(Yi, { children: e.message, ...t }) : null;
}, Ur = i("div", {
  _id: "aiChatForm__Footer"
}), Ji = i("button", {
  _id: "aiChatForm__Cancel",
  children: "Cancel"
}), Kr = (t) => {
  const { onClick: e, ...a } = t, { closeForm: s } = b();
  return /* @__PURE__ */ n(Ji, { onClick: h(e, s), ...a });
}, Xi = i("button", {
  _id: "aiChatForm__Submit",
  children: "Submit",
  type: "submit"
}), qr = (t) => {
  const { onClick: e, ...a } = t, { isSubmitting: s } = b();
  return /* @__PURE__ */ n(Xi, { disabled: s, ...a });
}, Zi = i("div", {
  _id: "aiChatForm__Success"
}), jr = (t) => {
  const { isSuccess: e } = b();
  return e ? /* @__PURE__ */ n(Zi, { ...t }) : null;
}, ea = i("h2", {
  _id: "aiChatForm__SuccessHeading"
}), Gr = (t) => {
  const { form: e } = b();
  return /* @__PURE__ */ n(ea, { children: e?.successView.heading, ...t });
}, ta = i(ce, {
  _id: "aiChatForm__SuccessMessage"
}), zr = (t) => {
  const { form: e } = b();
  return /* @__PURE__ */ n(ta, { children: e?.successView.message, ...t });
}, ia = i("button", {
  _id: "aiChatForm__SuccessButton"
}), Yr = (t) => {
  const { onClick: e, ...a } = t, { form: s, closeForm: r } = b(), o = s?.successView?.doneButton;
  if (!o) return null;
  const c = o.icon && /* @__PURE__ */ n(B, { iconSettings: o.icon }), d = o.label;
  return /* @__PURE__ */ n(
    ia,
    {
      onClick: h(e, r),
      children: /* @__PURE__ */ $(ee, { children: [
        c,
        d
      ] }),
      ...a
    }
  );
};
export {
  qs as ActionBar,
  js as Actions,
  Cs as AttachmentsBar,
  As as AttachmentsBarActions,
  vs as AttachmentsBarAttachment,
  bs as AttachmentsBarAttachmentDelete,
  gs as AttachmentsBarAttachmentIcon,
  _s as AttachmentsBarAttachmentTitle,
  Ds as AttachmentsBarForm,
  $s as AttachmentsBarFormContent,
  Us as AttachmentsBarFormContentError,
  Vs as AttachmentsBarFormContentInput,
  Qs as AttachmentsBarFormContentLabel,
  Ks as AttachmentsBarFormSubmitButton,
  Os as AttachmentsBarFormTitle,
  Rs as AttachmentsBarFormTitleError,
  Ns as AttachmentsBarFormTitleInput,
  Ws as AttachmentsBarFormTitleLabel,
  Ps as AttachmentsBarInfoTip,
  ri as AttachmentsBarInfoTipArrow,
  Fs as AttachmentsBarInfoTipIcon,
  Ms as AttachmentsBarInfoTipText,
  fs as AttachmentsBarInput,
  Ss as AttachmentsBarInputIcon,
  Is as AttachmentsBarInputs,
  ps as AttachmentsBarList,
  Es as AttachmentsBarModal,
  xs as AttachmentsBarModalBody,
  Ls as AttachmentsBarModalClose,
  Bs as AttachmentsBarModalContent,
  ws as AttachmentsBarModalDescription,
  Ts as AttachmentsBarModalHeader,
  ys as AttachmentsBarModalHeading,
  Hs as AttachmentsBarModalHelp,
  ks as AttachmentsBarModalOverlay,
  Me as ChatAction,
  Xs as ChatActionFeedback,
  Fi as ChatActionLabel,
  er as ChatHelpAction,
  en as Content,
  tn as ContentScrollArea,
  rn as ContentScrollAreaCorner,
  nn as ContentScrollAreaScrollbar,
  sn as ContentScrollAreaThumb,
  an as ContentScrollAreaViewport,
  Ga as ConversationLoading,
  cn as Disclaimer,
  un as DisclaimerArrow,
  ln as DisclaimerContent,
  dn as DisclaimerLabel,
  hn as DisclaimerText,
  mn as DisclaimerTrigger,
  qs as EmbeddedChatPrimitiveActionBar,
  js as EmbeddedChatPrimitiveActions,
  Cs as EmbeddedChatPrimitiveAttachmentsBar,
  As as EmbeddedChatPrimitiveAttachmentsBarActions,
  vs as EmbeddedChatPrimitiveAttachmentsBarAttachment,
  bs as EmbeddedChatPrimitiveAttachmentsBarAttachmentDelete,
  gs as EmbeddedChatPrimitiveAttachmentsBarAttachmentIcon,
  _s as EmbeddedChatPrimitiveAttachmentsBarAttachmentTitle,
  Ds as EmbeddedChatPrimitiveAttachmentsBarForm,
  $s as EmbeddedChatPrimitiveAttachmentsBarFormContent,
  Us as EmbeddedChatPrimitiveAttachmentsBarFormContentError,
  Vs as EmbeddedChatPrimitiveAttachmentsBarFormContentInput,
  Qs as EmbeddedChatPrimitiveAttachmentsBarFormContentLabel,
  Ks as EmbeddedChatPrimitiveAttachmentsBarFormSubmitButton,
  Os as EmbeddedChatPrimitiveAttachmentsBarFormTitle,
  Rs as EmbeddedChatPrimitiveAttachmentsBarFormTitleError,
  Ns as EmbeddedChatPrimitiveAttachmentsBarFormTitleInput,
  Ws as EmbeddedChatPrimitiveAttachmentsBarFormTitleLabel,
  Ps as EmbeddedChatPrimitiveAttachmentsBarInfoTip,
  ri as EmbeddedChatPrimitiveAttachmentsBarInfoTipArrow,
  Fs as EmbeddedChatPrimitiveAttachmentsBarInfoTipIcon,
  Ms as EmbeddedChatPrimitiveAttachmentsBarInfoTipText,
  fs as EmbeddedChatPrimitiveAttachmentsBarInput,
  Ss as EmbeddedChatPrimitiveAttachmentsBarInputIcon,
  Is as EmbeddedChatPrimitiveAttachmentsBarInputs,
  ps as EmbeddedChatPrimitiveAttachmentsBarList,
  Es as EmbeddedChatPrimitiveAttachmentsBarModal,
  xs as EmbeddedChatPrimitiveAttachmentsBarModalBody,
  Ls as EmbeddedChatPrimitiveAttachmentsBarModalClose,
  Bs as EmbeddedChatPrimitiveAttachmentsBarModalContent,
  ws as EmbeddedChatPrimitiveAttachmentsBarModalDescription,
  Ts as EmbeddedChatPrimitiveAttachmentsBarModalHeader,
  ys as EmbeddedChatPrimitiveAttachmentsBarModalHeading,
  Hs as EmbeddedChatPrimitiveAttachmentsBarModalHelp,
  ks as EmbeddedChatPrimitiveAttachmentsBarModalOverlay,
  Me as EmbeddedChatPrimitiveChatAction,
  Xs as EmbeddedChatPrimitiveChatActionFeedback,
  Fi as EmbeddedChatPrimitiveChatActionLabel,
  er as EmbeddedChatPrimitiveChatHelpAction,
  en as EmbeddedChatPrimitiveContent,
  tn as EmbeddedChatPrimitiveContentScrollArea,
  rn as EmbeddedChatPrimitiveContentScrollAreaCorner,
  nn as EmbeddedChatPrimitiveContentScrollAreaScrollbar,
  sn as EmbeddedChatPrimitiveContentScrollAreaThumb,
  an as EmbeddedChatPrimitiveContentScrollAreaViewport,
  Ga as EmbeddedChatPrimitiveConversationLoading,
  cn as EmbeddedChatPrimitiveDisclaimer,
  un as EmbeddedChatPrimitiveDisclaimerArrow,
  ln as EmbeddedChatPrimitiveDisclaimerContent,
  dn as EmbeddedChatPrimitiveDisclaimerLabel,
  hn as EmbeddedChatPrimitiveDisclaimerText,
  mn as EmbeddedChatPrimitiveDisclaimerTrigger,
  gn as EmbeddedChatPrimitiveExampleQuestion,
  _n as EmbeddedChatPrimitiveExampleQuestionButton,
  Cn as EmbeddedChatPrimitiveExampleQuestions,
  pn as EmbeddedChatPrimitiveExampleQuestionsLabel,
  vn as EmbeddedChatPrimitiveExampleQuestionsList,
  hr as EmbeddedChatPrimitiveFeedbackForm,
  ur as EmbeddedChatPrimitiveFeedbackItem,
  Cr as EmbeddedChatPrimitiveFeedbackItemCheckbox,
  pr as EmbeddedChatPrimitiveFeedbackItemCheckboxIndicator,
  gr as EmbeddedChatPrimitiveFeedbackItemDescription,
  vr as EmbeddedChatPrimitiveFeedbackItemLabel,
  rr as EmbeddedChatPrimitiveFeedbackModal,
  lr as EmbeddedChatPrimitiveFeedbackModalBody,
  mr as EmbeddedChatPrimitiveFeedbackModalClose,
  cr as EmbeddedChatPrimitiveFeedbackModalContent,
  dr as EmbeddedChatPrimitiveFeedbackModalHeader,
  or as EmbeddedChatPrimitiveFeedbackModalOverlay,
  _r as EmbeddedChatPrimitiveFeedbackSubmitButton,
  cs as EmbeddedChatPrimitiveFooter,
  Ar as EmbeddedChatPrimitiveForm,
  Kr as EmbeddedChatPrimitiveFormCancel,
  Pr as EmbeddedChatPrimitiveFormClose,
  fr as EmbeddedChatPrimitiveFormContent,
  Ir as EmbeddedChatPrimitiveFormDescription,
  Vr as EmbeddedChatPrimitiveFormError,
  Sr as EmbeddedChatPrimitiveFormField,
  yr as EmbeddedChatPrimitiveFormFieldCheckbox,
  wr as EmbeddedChatPrimitiveFormFieldCheckboxIndicator,
  kr as EmbeddedChatPrimitiveFormFieldEmail,
  Qr as EmbeddedChatPrimitiveFormFieldError,
  Br as EmbeddedChatPrimitiveFormFieldFile,
  Er as EmbeddedChatPrimitiveFormFieldLabel,
  Hr as EmbeddedChatPrimitiveFormFieldSelect,
  Or as EmbeddedChatPrimitiveFormFieldSelectContent,
  Dr as EmbeddedChatPrimitiveFormFieldSelectIcon,
  Nr as EmbeddedChatPrimitiveFormFieldSelectItem,
  $r as EmbeddedChatPrimitiveFormFieldSelectItemIndicator,
  Rr as EmbeddedChatPrimitiveFormFieldSelectItemText,
  Lr as EmbeddedChatPrimitiveFormFieldSelectTrigger,
  xr as EmbeddedChatPrimitiveFormFieldSelectValue,
  Wr as EmbeddedChatPrimitiveFormFieldSelectViewport,
  Ie as EmbeddedChatPrimitiveFormFieldText,
  Tr as EmbeddedChatPrimitiveFormFieldTextArea,
  Ur as EmbeddedChatPrimitiveFormFooter,
  Fr as EmbeddedChatPrimitiveFormHeader,
  Mr as EmbeddedChatPrimitiveFormHeading,
  qr as EmbeddedChatPrimitiveFormSubmit,
  jr as EmbeddedChatPrimitiveFormSuccess,
  Yr as EmbeddedChatPrimitiveFormSuccessButton,
  Gr as EmbeddedChatPrimitiveFormSuccessHeading,
  zr as EmbeddedChatPrimitiveFormSuccessMessage,
  br as EmbeddedChatPrimitiveFormWrapper,
  Ja as EmbeddedChatPrimitiveHeaderToolbar,
  Zs as EmbeddedChatPrimitiveHelpActions,
  ir as EmbeddedChatPrimitiveHelpActionsMenu,
  ar as EmbeddedChatPrimitiveHelpActionsMenuArrow,
  nr as EmbeddedChatPrimitiveHelpActionsMenuItem,
  sr as EmbeddedChatPrimitiveHelpActionsMenuItemIcon,
  tr as EmbeddedChatPrimitiveHelpActionsTrigger,
  ls as EmbeddedChatPrimitiveInput,
  ds as EmbeddedChatPrimitiveInputFieldset,
  ms as EmbeddedChatPrimitiveInputGroup,
  In as EmbeddedChatPrimitiveIntroMessageWrapper,
  Kn as EmbeddedChatPrimitiveMessage,
  zn as EmbeddedChatPrimitiveMessageAction,
  Ln as EmbeddedChatPrimitiveMessageAttachments,
  Dn as EmbeddedChatPrimitiveMessageAttachmentsItem,
  On as EmbeddedChatPrimitiveMessageAttachmentsItemIcon,
  Wn as EmbeddedChatPrimitiveMessageAttachmentsItemTitle,
  xn as EmbeddedChatPrimitiveMessageAttachmentsList,
  Nn as EmbeddedChatPrimitiveMessageAttachmentsPreview,
  Un as EmbeddedChatPrimitiveMessageAttachmentsPreviewBody,
  Vn as EmbeddedChatPrimitiveMessageAttachmentsPreviewClose,
  $n as EmbeddedChatPrimitiveMessageAttachmentsPreviewContent,
  Qn as EmbeddedChatPrimitiveMessageAttachmentsPreviewHeader,
  Rn as EmbeddedChatPrimitiveMessageAttachmentsPreviewOverlay,
  En as EmbeddedChatPrimitiveMessageAvatar,
  kn as EmbeddedChatPrimitiveMessageAvatarContent,
  Bn as EmbeddedChatPrimitiveMessageAvatarFallback,
  Tn as EmbeddedChatPrimitiveMessageAvatarImage,
  Hn as EmbeddedChatPrimitiveMessageContent,
  wn as EmbeddedChatPrimitiveMessageContentWrapper,
  fn as EmbeddedChatPrimitiveMessageHeader,
  Sn as EmbeddedChatPrimitiveMessageLoading,
  yn as EmbeddedChatPrimitiveMessageName,
  Zn as EmbeddedChatPrimitiveMessageSourceItem,
  es as EmbeddedChatPrimitiveMessageSourceItemBreadcrumbs,
  ss as EmbeddedChatPrimitiveMessageSourceItemDescription,
  rs as EmbeddedChatPrimitiveMessageSourceItemDescriptionPart,
  is as EmbeddedChatPrimitiveMessageSourceItemIcon,
  os as EmbeddedChatPrimitiveMessageSourceItemIndicator,
  ns as EmbeddedChatPrimitiveMessageSourceItemTag,
  as as EmbeddedChatPrimitiveMessageSourceItemTitle,
  Yn as EmbeddedChatPrimitiveMessageSources,
  Jn as EmbeddedChatPrimitiveMessageSourcesHeader,
  Xn as EmbeddedChatPrimitiveMessageSourcesList,
  Gn as EmbeddedChatPrimitiveMessageToolAction,
  jn as EmbeddedChatPrimitiveMessageToolActions,
  qn as EmbeddedChatPrimitiveMessageToolbar,
  Pt as EmbeddedChatPrimitiveMessageWrapper,
  on as EmbeddedChatPrimitiveMessages,
  za as EmbeddedChatPrimitiveRoot,
  hs as EmbeddedChatPrimitiveSendButton,
  us as EmbeddedChatPrimitiveSendButtonIcon,
  Js as EmbeddedChatPrimitiveTaglineBrandName,
  Gs as EmbeddedChatPrimitiveTaglineContainer,
  Ys as EmbeddedChatPrimitiveTaglineLogo,
  zs as EmbeddedChatPrimitiveTaglineText,
  Za as EmbeddedChatPrimitiveToolbarHeader,
  Xa as EmbeddedChatPrimitiveToolbarHeaderWrapper,
  Fn as EmbeddedChatPrimitiveWorkflow,
  Mn as EmbeddedChatPrimitiveWorkflowIcon,
  bn as EmbeddedChatPrimitiveWorkflows,
  An as EmbeddedChatPrimitiveWorkflowsLabel,
  Pn as EmbeddedChatPrimitiveWorkflowsList,
  ja as EmbeddedChatPrimitiveWrapper,
  gn as ExampleQuestion,
  _n as ExampleQuestionButton,
  Cn as ExampleQuestions,
  pn as ExampleQuestionsLabel,
  vn as ExampleQuestionsList,
  hr as FeedbackForm,
  ur as FeedbackItem,
  Cr as FeedbackItemCheckbox,
  pr as FeedbackItemCheckboxIndicator,
  gr as FeedbackItemDescription,
  vr as FeedbackItemLabel,
  rr as FeedbackModal,
  lr as FeedbackModalBody,
  mr as FeedbackModalClose,
  cr as FeedbackModalContent,
  dr as FeedbackModalHeader,
  or as FeedbackModalOverlay,
  _r as FeedbackSubmitButton,
  cs as Footer,
  Ar as Form,
  Kr as FormCancel,
  Pr as FormClose,
  fr as FormContent,
  Ir as FormDescription,
  Vr as FormError,
  Sr as FormField,
  yr as FormFieldCheckbox,
  wr as FormFieldCheckboxIndicator,
  kr as FormFieldEmail,
  Qr as FormFieldError,
  Br as FormFieldFile,
  Er as FormFieldLabel,
  Hr as FormFieldSelect,
  Or as FormFieldSelectContent,
  Dr as FormFieldSelectIcon,
  Nr as FormFieldSelectItem,
  $r as FormFieldSelectItemIndicator,
  Rr as FormFieldSelectItemText,
  Lr as FormFieldSelectTrigger,
  xr as FormFieldSelectValue,
  Wr as FormFieldSelectViewport,
  Ie as FormFieldText,
  Tr as FormFieldTextArea,
  Ur as FormFooter,
  Fr as FormHeader,
  Mr as FormHeading,
  qr as FormSubmit,
  jr as FormSuccess,
  Yr as FormSuccessButton,
  Gr as FormSuccessHeading,
  zr as FormSuccessMessage,
  br as FormWrapper,
  Ya as Header,
  Ja as HeaderToolbar,
  Xa as HeaderToolbarWrapper,
  Zs as HelpActions,
  ir as HelpActionsMenu,
  ar as HelpActionsMenuArrow,
  nr as HelpActionsMenuItem,
  sr as HelpActionsMenuItemIcon,
  tr as HelpActionsTrigger,
  ls as Input,
  ds as InputFieldset,
  ms as InputGroup,
  In as IntroMessageWrapper,
  Kn as Message,
  zn as MessageAction,
  Ln as MessageAttachments,
  Dn as MessageAttachmentsItem,
  On as MessageAttachmentsItemIcon,
  Wn as MessageAttachmentsItemTitle,
  xn as MessageAttachmentsList,
  Nn as MessageAttachmentsPreview,
  Un as MessageAttachmentsPreviewBody,
  Vn as MessageAttachmentsPreviewClose,
  $n as MessageAttachmentsPreviewContent,
  Qn as MessageAttachmentsPreviewHeader,
  Rn as MessageAttachmentsPreviewOverlay,
  En as MessageAvatar,
  kn as MessageAvatarContent,
  Bn as MessageAvatarFallback,
  Tn as MessageAvatarImage,
  Hn as MessageContent,
  wn as MessageContentWrapper,
  fn as MessageHeader,
  Sn as MessageLoading,
  yn as MessageName,
  Zn as MessageSourceItem,
  ts as MessageSourceItemBreadcrumbIcon,
  es as MessageSourceItemBreadcrumbs,
  ss as MessageSourceItemDescription,
  rs as MessageSourceItemDescriptionPart,
  is as MessageSourceItemIcon,
  os as MessageSourceItemIndicator,
  ns as MessageSourceItemTag,
  as as MessageSourceItemTitle,
  Yn as MessageSources,
  Jn as MessageSourcesHeader,
  Xn as MessageSourcesList,
  Gn as MessageToolAction,
  jn as MessageToolActions,
  qn as MessageToolbar,
  Pt as MessageWrapper,
  on as Messages,
  Zr as Provider,
  za as Root,
  hs as SendButton,
  us as SendButtonIcon,
  Js as TaglineBrandName,
  Gs as TaglineContainer,
  Ys as TaglineLogo,
  zs as TaglineText,
  Za as ToolbarHeader,
  Fn as Workflow,
  Mn as WorkflowIcon,
  bn as Workflows,
  An as WorkflowsLabel,
  Pn as WorkflowsList,
  ja as Wrapper
};
